import { z } from 'zod';

export const DeviceSchema = z.object({
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  fingerprint: z.string().nullable().optional(),
});
